<template lang="pug">
.member-open-gift-container(v-if="true" :class="isExchange?'':'isExchange'")
  .memmber-title
    .memmber-title-word 会员开卡礼
    .memmber-title-subword(v-if="isExchange") 以下礼品可任选1件
  .member-list(v-if="isExchange")
    .list-item(v-for="(item,index) in memberList "
      @click="chooseList(item,index)"
      :class="chooseOne===index?'choose-item':''")
      .list-logo(v-if="chooseOne===index")
        img(src="https://m.hellobike.com/resource/gallery/61/6vfCv7ZKcA.png?x-oss-process=image/quality,q_80")
      .list-img
        img(:src="item.displayPic")
  .choose-btn(v-if="isExchange" @click="chooseThis()") 就选TA了
  .exchanged-block(v-if="!isExchange")
    .exchanged-left
      .exchanged-left-img(@click="checkCode")
        img(:src="getPic()")
  RedemptionCode(v-if="redemptionCode"
  :show.sync="redemptionCode"
  :redemptionData="redemptionData"
  :successOver="successOver")
  receviceSure(v-if="sureRevice"
  :show.sync="sureRevice"
  @openReceive="openReceive")
</template>
<script>
import { receiveTakeBonus } from '@/api/vip';
import {
  getTokenAndLocation,
} from '@/utils';
import Toast from '@/components/toast';
import RedemptionCode from './redemption-code.vue';
import receviceSure from './recevice-sure.vue';
import { getSystemCode } from '../../../../utils/systemCode';

export default {
  components: {
    RedemptionCode,
    receviceSure,
  },
  props: {
    // isExchange: {
    //   type: Boolean,
    //   default: true,
    // },
    giftData: {
      type: Array,
      default: () => ([]),
    },
    propVersion: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chooseOne: 0,
      isReceive: false,
      sureRevice: false,
      redemptionCode: false,
      chooseData: null,
      redemptionData: null,
      memberList: [],
      isExchange: false,
      successOver: true,
    };
  },
  watch: {
    giftData: {
      handler(newGiftData) {
        this.updateData(newGiftData);
      },
      deep: true,
    },
  },
  created() {
    this.updateData(this.giftData);
  },
  methods: {
    getPic() {
      if (this.memberList && this.memberList.length > 0 && this.memberList[0]) {
        return this.memberList[0].displayPic;
      }
      return '';
    },
    updateData(data) {
      if (Array.isArray(data) && data.length > 0) {
        const bonus = data[0] && data[0].moduleData && data[0].moduleData.bonus;
        this.memberList = bonus || [];
        this.isExchange = bonus && bonus[0] && bonus[0].bonusStatus !== 2;
      } else {
        this.memberList = [];
        this.isExchange = false;
      }
    },
    chooseList(item, index) {
      this.chooseOne = index;
    },
    chooseThis() {
      this.chooseData = this.memberList[this.chooseOne];
      this.sureRevice = true;
      this.successOver = true;
    },
    checkCode() {
      // eslint-disable-next-line prefer-destructuring
      this.redemptionData = this.memberList[0];
      this.successOver = false;
      this.redemptionCode = true;
    },
    async openReceive() {
      const { token, cityCode } = await getTokenAndLocation();
      let tempCampaignId = null;
      let tempCampaignCode = null;
      if (this.giftData && this.giftData[0] && this.giftData[0].moduleData && this.giftData[0].moduleData.campaignId) {
        tempCampaignId = this.giftData[0].moduleData.campaignId;
      }
      if (this.giftData && this.giftData[0] && this.giftData[0].moduleData && this.giftData[0].moduleData.campaignCode) {
        tempCampaignCode = this.giftData[0].moduleData.campaignCode;
      }
      try {
        const res = await receiveTakeBonus({
          token,
          appCode: 'platform',
          goodsType: 1,
          propVersion: this.propVersion,
          systemCode: getSystemCode(),
          cityCode,
          campaignId: tempCampaignId,
          campaignCode: tempCampaignCode,
          receiveBonusIds: [this.chooseData.guid],
        });
        if (res.data) {
          if (res.data.bonus && res.data.bonus.length > 0) {
            // eslint-disable-next-line prefer-destructuring
            this.redemptionData = res.data.bonus[0];
            this.redemptionCode = true;
            this.$emit('refreshData');
          }
        } else {
          Toast.show('暂无数据');
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        Toast.show(e);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.member-open-gift-container {
  background: #fff;
  width: 3.55rem;
  height: 1.42rem;
  padding: 0.06rem 0 0 0.14rem;
  border-radius: 0.16rem;
  overflow: hidden;
  margin: 0.1rem;
  margin-right: 0.5rem;

  .memmber-title {
    font-family: PingFangSC, PingFang SC, sans-serif;
    font-size: 0.16rem;
    font-weight: 600;
    line-height: 0.22rem;
    color: #242729;
    display: flex;

    .memmber-title-subword {
      font-family: PingFangSC, PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 400;
      line-height: 0.168rem;
      margin-top: 0.04rem;
      margin-left: 0.08rem;
    }
  }

  .member-list {
    margin-top: 0.11rem;
    display: flex;
    flex-wrap: nowrap;
    flex: 1;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    height: 0.42rem;

    .list-item {
      border-radius: 0.08rem;
      border: 0.01rem solid #e1e6eb;
      margin-right: 0.04rem;
      width: 1.16rem;
      height: 0.4rem;
      position: relative;

      .list-logo {
        position: absolute;
        top: 0;
        right: 0;
        background: #ff5729;
        width: 0.16rem;
        height: 0.1rem;
        border-radius: 0 0.05rem 0 0.08rem;

        img {
          position: absolute;
          top: 0.02rem;
          right: 0.04rem;
          width: 0.08rem;
          height: 0.07rem;
        }
      }

      .list-img {
        margin-right: 0.04rem;

        img {
          width: 1.16rem;
          height: 0.4rem;
          border-radius: 0.07rem;
        }
      }

      .list-word {
        margin-top: 0.04rem;

        .list-topword {
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-size: 0.12rem;
          font-weight: 500;
          line-height: 0.168rem;
          color: #3b1401;
        }

        .list-subword {
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-size: 0.11rem;
          font-weight: 400;
          line-height: 0.154rem;
          color: #a47565;
        }
      }
    }

    .choose-item {
      border: 0.005rem solid #ff5729;
    }

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }
  }

  .choose-btn {
    width: 1.26rem;
    height: 0.32rem;
    border: 0.01rem solid #deb1a5;
    text-align: center;
    line-height: 0.32rem;
    font-family: PingFangSC, PingFang SC, sans-serif;
    font-size: 0.14rem;
    font-weight: 500;
    border-radius: 0.5rem;
    color: #7d3b2a;
    margin: 0.12rem auto 0 auto;
  }

  .exchanged-block {
    width: 3.21rem;
    height: 0.46rem;
    border-radius: 0.1rem;
    margin-top: 0.08rem;

    .exchanged-left {
      display: flex;

      .exchanged-left-img {
        margin-right: 0.08rem;

        img {
          width: 3.21rem;
          height: 0.46rem;
          border-radius: 0.07rem;
        }
      }

      .exchanged-left-word {
        margin-top: 0.03rem;

        .exchanged-left-word-title {
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-size: 0.12rem;
          font-weight: 500;
          color: #3b1401;
        }

        .exchanged-left-word-subtitle {
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-size: 0.11rem;
          font-weight: 400;
          text-align: left;
          color: #a47565;
        }
      }
    }

    .exchanged-right {
      margin-top: 0.1rem;
      font-family: PingFangSC, PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 400;
      text-align: center;
      color: #7d3b2a;
      display: flex;

      img {
        margin-top: 0.02rem;
        width: 0.12rem;
        height: 0.12rem;
      }
    }
  }
}

.isExchange {
  height: 1.04rem;
}
</style>
